// extracted by mini-css-extract-plugin
export default {"text":"event-location-box_text__6KJkw"};